let nav = $(".nav");
let hamburgerMobile = $("#hamburger-mobile");
let icons = $(".hamburger_icons");

$(window)
    .resize(function () {
        var width = $(window).width();

        if (width > 767) {
            $(".custom_select").on("keydown", function (e) {
                if (e.keyCode == 13 || e.keyCode == 38 || e.keyCode == 40) {
                    $("#select2-drop-mask").click();
                    $(
                        ".select2-container--open .select2-search__field"
                    ).focus();
                    e.preventDefault();
                }
            });

            $(".custom_select").select2();
            $(".advaced-select-wrapper .custom_select").select2({
                dropdownParent: $("#advancedSearchModal"),
            });
            $(".lastminute_select").select2({
                dropdownParent: $("#myTabContent"),
            });
            $(".accordion_select").select2({
                dropdownParent: $("#accordionSearchTwo"),
            });
            $(".search_select").select2({
                dropdownParent: $("#collapseAccordionSearchOne"),
            });

            $(".lastminute_dest").select2({
                dropdownParent: $("#lastMinuteDest"),
                dropdownCss: { "z-index": "1000" },
            });

            $(".country_select").select2({
                dropdownParent: $("#bookingStepModal"),
            });
            $(".custom_select_sort").select2();
        }

        if (width < 992) {
            $(".header_top .wishlist").remove();
        }

        if (width > 1200) {
            if (nav.hasClass("opened")) {
                nav.removeClass("opened");
            }

            if (hamburgerMobile.hasClass("active")) {
                hamburgerMobile.removeClass("active");
            }
            if (icons.hasClass("icons-animate")) {
                icons.removeClass("icons-animate");
            }
        }
    })
    .resize();

$(document).on("select2:open", (e) => {
    const selectId = e.target.id;
    $(
        ".select2-search__field[aria-controls='select2-" +
            selectId +
            "-results']"
    ).each(function (key, value) {
        value.focus();
    });
});

$(document).ready(function () {
    var hamburger = $("#hamburger");
    var hamburgerClose = $("#hamburger-close");
    let langMobile = $(".lang-mobile");
    let searchAside = $("#yachtlist");
    let searchMobileToggle = $("#aside-search-open");
    let body = $("body");

    $("a[href*=\\#]:not([href=\\#])").on("click", function () {
        if (
            location.pathname.replace(/^\//, "") ==
                this.pathname.replace(/^\//, "") &&
            location.hostname == this.hostname
        ) {
            var target = $(this.hash);
            target = target.length
                ? target
                : $("[name=" + this.hash.slice(1) + "]");
            if (target.length) {
                $("html,body").animate(
                    {
                        scrollTop: target.offset().top,
                    },
                    1000
                );
                return false;
            }
        }
    });

    //add class to modal backdrop
    $("#viewAllPhotosModal").on("show.bs.modal", function (e) {
        setTimeout(function () {
            $(".modal-backdrop").addClass("modal-backdrop--custom");
        });
    });

    //toggle search side on mobile
    searchMobileToggle.on("click", function () {
        searchAside.addClass("active-search");
        body.addClass("hidden-scroll");
    });
    $("#aside-search-close").on("click", function () {
        searchAside.removeClass("active-search");
        body.removeClass("hidden-scroll");
    });

    //tabs
    $(".nav-tabs .nav-item.nav-link").click(function () {
        $(".nav-tabs .nav-item.nav-link.active").removeClass("active");
        $(this).addClass("active");
    });

    //show yachtdetails calendar
    $(".add-date-btn").on("click", function () {
        $(".yachtdetails-calendar").toggleClass("show");
    });

    //open booking request
    $(".open-booking").each(function (index) {
        $(this).on("click", function () {
            $(".custom-modal").addClass("open");
        });
    });

    $(".open-quote").each(function (index) {
        $(this).on("click", function () {
            $(".custom-modal-quote").addClass("open");
        });
    });

    $(".close-quote").on("click", function () {
        $(".custom-modal-quote").removeClass("open");
    });

    $("#bookingRequestClose").on("click", function () {
        $(".custom-modal").removeClass("open");
    });

    // Open on desktop secondary menu
    hamburger.on("click", function () {
        icons.toggleClass("icons-animate");
        $(this).toggleClass("active");
    });

    // Open on mobile language
    langMobile.on("click", function () {
        $([".lang-list, .lang-btn"]).toggleClass("active-lang");
    });

    // Open on mobile primary menu
    hamburgerMobile.on("click", function () {
        if ($(this).hasClass("active")) {
            nav.removeClass("opened");
            icons.removeClass("icons-animate");
            $(this).removeClass("active");
            $("body").removeClass("nav-open");
            $(".header").removeClass("header-absolute");
        } else {
            nav.addClass("opened");
            icons.addClass("icons-animate");
            $(this).addClass("active");
            $("body").addClass("nav-open");
            $(".header").addClass("header-absolute");
        }
    });

    // Close drawer on desktop
    hamburgerClose.on("click", function () {
        icons.removeClass("icons-animate");
        hamburger.removeClass("active");
    });

    //dropdown menu on click
    var navLink = $(".main-nav > li.has-submenu span.first-menu-span");
    var dropDown = $(".sub-menu");
    showSubMenusOnMobile(navLink, dropDown);

    //subdropdown menu on click
    var navLinkSub = $(
        ".sub-menu > li.has-dropdown-submenu  span.second-menu-span"
    );
    var dropDownSub = $(".has-dropdown-menu");
    showSubMenusOnMobile(navLinkSub, dropDownSub);

    function showSubMenusOnMobile(links, dropdowns) {
        links.on("click", function () {
            if ($(this).next(dropdowns).is(":visible")) {
                $(this).removeClass("active");
                $(this).next(dropdowns).slideUp();
            } else {
                $(links).removeClass("active");
                $(this).addClass("active");
                $(links).next(dropdowns).slideUp();
                $(this).next(dropdowns).slideToggle();
            }
        });
    }

    // show form on button click
    $("#show-form").on("click", function (e) {
        e.preventDefault();
        $(".animated-form").toggleClass("active");
    });

    //Show call icons
    $(".call-icon").on("click", function () {
        if ($(this).hasClass("active-icon")) {
            $(".call-icon").removeClass("active-icon");
        } else {
            $(this).addClass("active-icon");
        }
        $(".call-icons-list").toggleClass("active");
    });

    // Add smooth scrolling to all links
    $("a").on("click", function (event) {
        if (this.hash !== "") {
            event.preventDefault();
            var hash = this.hash;

            $("html, body").animate(
                {
                    scrollTop: $(hash).offset().top,
                },
                800,
                function () {
                    window.location.hash = hash;
                }
            );
        }
    });

    const imageGallery = $(".my-gallery");
    if (imageGallery) {
        let lightbox = new PhotoSwipeLightbox({
            gallery: ".my-gallery",
            children: "a",
            showHideAnimationType: "none",
            pswpModule: PhotoSwipe,
        });
        lightbox.init();
    }

    //Contact form valitadion
    $("#contact_form").validate({
        // Rules for form validation
        rules: {
            name: {
                required: true,
            },
            surname: {
                required: true,
            },
            email: {
                required: true,
                email: true,
            },
        },

        // Messages for form validation
        messages: {
            name: {
                required: "Please enter first name",
            },
            surname: {
                required: "Please enter surname",
            },

            email: {
                required: "Please enter your email address",
            },
        },
    });

    //Contact form valitadion
    $("#included_form").validate({
        // Rules for form validation
        rules: {
            name: {
                required: true,
            },
            email: {
                required: true,
                email: true,
            },

            terms2: {
                required: true,
            },
        },

        // Messages for form validation
        messages: {
            name: {
                required: "Please enter first name",
            },
            surname: {
                required: "Please enter surname",
            },

            email: {
                required: "Please enter your email address",
            },
            terms: {
                required: "Please accept our policy",
            },
        },
    });

    //Booking Contact form valitadion
    $("#booking_contact_form").validate({
        // Rules for form validation
        rules: {
            name: {
                required: true,
            },
            email: {
                required: true,
                email: true,
            },
            message: {
                required: true,
            },

            policyCheck: {
                required: true,
            },
        },

        // Messages for form validation
        messages: {
            name: {
                required: "Please enter first name",
            },
            message: {
                required: "Please enter message",
            },

            email: {
                required: "Please enter your email address",
            },
            termsCheck: {
                required: "Please accept our policy",
            },
            policyCheck: {
                required: "Please accept our policy",
            },
        },
    });
});

//scroll from top and change header style
$(window).scroll(function () {
    if ($(window).scrollTop() > 150) {
        $(".header-home").addClass("header-shrink");
        $(".header_top").addClass("remove");
    } else {
        $(".header-home").removeClass("header-shrink");
        $(".header_top").removeClass("remove");
    }
});

//scroll to top  button
let calculateScrollValue = () => {
    let progress = $(".scroll-progress");
    let pos = $(window).scrollTop();
    let calcHeight = $(document).height() - $(window).height();
    let scrollValue = Math.round((pos * 100) / calcHeight);

    if (pos > 100) {
        progress.addClass("show-progress");
    } else {
        progress.removeClass("show-progress");
    }

    progress.on("click", function () {
        $(window).scrollTop(0);
    });

    progress.css(
        "background",
        `conic-gradient(#020f38 ${scrollValue}%, #3c91f9 ${scrollValue}%)`
    );
};

$(window).on("scroll", function () {
    calculateScrollValue();
});

document.addEventListener("DOMContentLoaded", function () {
    /*Cookies popup window*/
    setTimeout(function () {
        $("#cookieConsent").fadeIn(400);
    }, 3000);
    $("#closeCookieConsent, .cookieConsentOK").click(function () {
        $("#cookieConsent").fadeOut(400);
    });

    //Getting page information
    let current_url = window.location.href;

    //Get icon ids
    let facebook = document.getElementById("fb");
    let linkedin = document.getElementById("linkedin");
    let whatsapp = document.getElementById("whatsapp");
    //Facebook
    facebook?.addEventListener("click", function () {
        let fb_shareUrl =
            "https://www.facebook.com/sharer/sharer.php?u=" +
            encodeURIComponent(current_url);
        let window_size = "width=565,height=569";
        window.open(
            fb_shareUrl,
            "",
            "menubar=no,resizeable=yes,scrollbars=yes," + window_size
        );
        return false;
    });

    //likedin
    linkedin?.addEventListener("click", function () {
        window.open(
            "http://www.linkedin.com/shareArticle?mini=true&url=" +
                encodeURIComponent(current_url),
            "",
            "left=0,top=0,width=650,height=420,personalbar=0,toolbar=0,scrollbars=0,resizable=0"
        );
        return false;
    });

    //whatsapp
    whatsapp?.addEventListener("click", function () {
        var url = encodeURIComponent(current_url);
        var message = encodeURIComponent("Check out this blog post!");
        window.location.href = "whatsapp://send?text=" + message + "%20" + url;
    });

    //Print document
    document.getElementById("btnPrint")?.addEventListener("click", function () {
        printElement(document.getElementById("printThis"));
    });

    function printElement(elem) {
        var domClone = elem.cloneNode(true);

        var $printSection = document.getElementById("printSection");

        if (!$printSection) {
            var $printSection = document.createElement("div");
            $printSection.id = "printSection";
            document.body.appendChild($printSection);
        }

        $printSection.innerHTML = "";
        $printSection.appendChild(domClone);
        window.print();
    }

    //accrodion scroll to beginning of content on click

    let accordionWrapper = document.querySelectorAll(".accordion-faq");
    let header = document.querySelector(".header");

    accordionWrapper.forEach(function (wrap) {
        let accrdionItem = wrap.querySelectorAll(".collapse");

        accrdionItem.forEach(function (item) {
            item.addEventListener("shown.bs.collapse", function () {
                let headerHeight = header.getBoundingClientRect().height;

                let scrollOffsetAcc =
                    wrap.scrollTop + item.parentNode.offsetTop - headerHeight;

                window.scrollTo({ top: scrollOffsetAcc, behavior: "smooth" });
            });
        });
    });

    //hover tool tip on extras
    let allTooltips = document.querySelectorAll(".equipment-img");

    allTooltips.forEach(function (el) {
        el.addEventListener("mouseenter", function () {
            allTooltips.forEach(function (e) {
                let toolTip = e.querySelector(".tooltip");
                toolTip.classList.add("hidden");
                toolTip.classList.remove("show");
            });
            this.querySelector(".tooltip").classList.add("show");
        });

        el.addEventListener("mouseleave", function () {
            allTooltips.forEach(function (e) {
                let toolTip = e.querySelector(".tooltip");
                toolTip.classList.add("hidden");
                toolTip.classList.remove("show");
            });
            this.querySelector(".tooltip").classList.add("hidden");
        });

        el.addEventListener("click", function () {
            el.children[0].classList.toggle("show");
        });
    });

    //limit text in the yacht cabins
    let dataCabins = document.querySelectorAll(".data-cabins");
    dataCabins.forEach((item) => {
        let newText = item.innerText.slice(0, 2);
        item.innerHTML = newText;
    });

    const breakpoint = window.matchMedia('(min-width: 992px)');

let swiperInstances = [];

function handleBreakpointChange() {
  // Destroy existing Swipers
  swiperInstances.forEach(instance => instance.destroy(true, true));
  swiperInstances = [];

  if (breakpoint.matches) {
    // Desktop view (>= 992px)
    
    // Init .yachts-slider with 4 slides per view
    document.querySelectorAll('.yachts-slider').forEach(slider => {
      const swiper = new Swiper(slider, {
        spaceBetween: 20,
        slidesPerView: 4,
        plugins: [SwiperPluginPagination, SwiperPluginNavigation],
        // pagination: {
        //   el: ".yachts-slider .swiper-plugin-pagination",
        //   clickable: true,
        //   bulletClass: "swiper-plugin-pagination__item",
        //   bulletActiveClass: "is-active"
        // },
        // navigation: {
        //   prevEl: ".yachts-slider .swiper-plugin-navigation-prevEl",
        //   nextEl: ".yachts-slider .swiper-plugin-navigation-nextEl"
        // }
      });
      swiperInstances.push(swiper);
    });

    // Init .home-blog-slider with 3 slides per view
    document.querySelectorAll('.home-blog-slider').forEach(slider => {
      const swiper = new Swiper(slider, {
        spaceBetween: 20,
        slidesPerView: 3,
        plugins: [SwiperPluginPagination, SwiperPluginNavigation],
        pagination: {
          el: ".home-blog-slider .swiper-plugin-pagination",
          clickable: true,
          bulletClass: "swiper-plugin-pagination__item",
          bulletActiveClass: "is-active"
        },
        navigation: {
          prevEl: ".home-blog-slider .swiper-plugin-navigation-prevEl",
          nextEl: ".home-blog-slider .swiper-plugin-navigation-nextEl"
        }
      });
      swiperInstances.push(swiper);
    });

  } else {
    // Mobile view (< 992px) — all sliders with 1 slide per view

    // Init .yachts-slider with 1 slide per view
    document.querySelectorAll('.yachts-slider').forEach(slider => {
      const swiper = new Swiper(slider, {
        spaceBetween: 20,
        slidesPerView: 1,
        plugins: [SwiperPluginPagination, SwiperPluginNavigation],
        pagination: {
          el: ".swiper-plugin-pagination",
          clickable: true,
          bulletClass: "swiper-plugin-pagination__item",
          bulletActiveClass: "is-active"
        },
        navigation: {
          prevEl: ".swiper-plugin-navigation-prevEl",
          nextEl: ".swiper-plugin-navigation-nextEl"
        }
      });
      swiperInstances.push(swiper);
    });

    // Init .home-blog-slider with 1 slide per view
    document.querySelectorAll('.home-blog-slider').forEach(slider => {
      const swiper = new Swiper(slider, {
        spaceBetween: 20,
        slidesPerView: 1,
        plugins: [SwiperPluginPagination, SwiperPluginNavigation],
        pagination: {
          el: ".swiper-plugin-pagination",
          clickable: true,
          bulletClass: "swiper-plugin-pagination__item",
          bulletActiveClass: "is-active"
        },
        navigation: {
          prevEl: ".swiper-plugin-navigation-prevEl",
          nextEl: ".swiper-plugin-navigation-nextEl"
        }
      });
      swiperInstances.push(swiper);
    });
  }
}

breakpoint.addEventListener('change', handleBreakpointChange);
handleBreakpointChange();

});
// END TINY SWIPER

//show btn on image mouse over
const sections = document.querySelectorAll(".routes-wrapper");
sections?.forEach((section) => {
    const btnSection = section.querySelector(".btn-show-more");

    section.addEventListener("mouseenter", () => {
        btnSection.style.visibility = "visible";
    });

    section.addEventListener("mouseleave", () => {
        btnSection.style.visibility = "hidden";
    });

    section.addEventListener("mousemove", (e) => {
        const mouseX = e.clientX;
        const mouseY = e.clientY;

        const sectionRect = section.getBoundingClientRect();
        const offsetX = mouseX - sectionRect.left;
        const offsetY = mouseY - sectionRect.top;

        btnSection.style.transform = `translate3d(${offsetX}px,${offsetY}px,0)`;
    });
});

// Free quote / make a request contact steps
document.addEventListener("DOMContentLoaded", function () {
  const formWrapper = document.querySelector(".free-quote-form");
    const includedForm = document.getElementById("included_form");

    if (formWrapper) {
        const step0 = formWrapper.querySelector(".free-quote-form-step-0");
        const step1 = formWrapper.querySelector(".free-quote-form-step-1");
        const step2 = formWrapper.querySelector(".free-quote-form-step-2");
        const step3 = formWrapper.querySelector(".free-quote-form-step-3");

        const nextButtons = formWrapper.querySelectorAll(".form-btn-next");
        const prevButtons = formWrapper.querySelectorAll(".form-btn-prev");

        // Initially show only step 0, hide others
        step0.style.display = "block";
        step1.style.display = "none";
        step2.style.display = "none";
        step3.style.display = "none";

        nextButtons.forEach(button => {
            button.addEventListener("click", function (e) {
                e.preventDefault();
                if (step0.style.display === "block") {
                    step0.style.display = "none";
                    step1.style.display = "block";
                } else if (step1.style.display === "block") {
                    step1.style.display = "none";
                    step2.style.display = "block";
                } else if (step2.style.display === "block") {
                    step2.style.display = "none";
                    step3.style.display = "block";
                }
            });
        });

        prevButtons.forEach(button => {
            button.addEventListener("click", function (e) {
                e.preventDefault();
                if (step3.style.display === "block") {
                    step3.style.display = "none";
                    step2.style.display = "block";
                } else if (step2.style.display === "block") {
                    step2.style.display = "none";
                    step1.style.display = "block";
                } else if (step1.style.display === "block") {
                    step1.style.display = "none";
                    step0.style.display = "block";
                }
            });
        });
    }

    // Function to set stars for all testimonial cards
    function setStars() {
        const testimonialCards = document.querySelectorAll(".card-testimonial");

        testimonialCards.forEach((card) => {
            const starsContainer = card.querySelector(".stars");
            const rating = parseInt(
                starsContainer.querySelector("b").textContent
            );
            starsContainer.querySelector("b").style.display = "none";

            const starContainer =
                starsContainer.querySelector(".star-container");

            starContainer.innerHTML = "";

            for (let i = 0; i < 5; i++) {
                const starSVG = document.createElementNS(
                    "http://www.w3.org/2000/svg",
                    "svg"
                );
                starSVG.setAttribute("width", "31");
                starSVG.setAttribute("height", "31");
                starSVG.setAttribute("viewBox", "0 0 31 31");

                const starPath = document.createElementNS(
                    "http://www.w3.org/2000/svg",
                    "path"
                );
                starPath.setAttribute(
                    "d",
                    "M14.6483 1.81699C15.0151 1.07374 16.0749 1.07374 16.4417 1.81699L19.7718 8.56449C19.9175 8.85964 20.1991 9.06421 20.5248 9.11154L27.9711 10.1935C28.7913 10.3127 29.1188 11.3207 28.5253 11.8992L23.1371 17.1514C22.9014 17.3812 22.7939 17.7122 22.8495 18.0366L24.1215 25.4528C24.2616 26.2697 23.4042 26.8927 22.6705 26.507L16.0103 23.0055C15.719 22.8524 15.371 22.8524 15.0797 23.0055L8.41948 26.507C7.68585 26.8927 6.82842 26.2697 6.96853 25.4528L8.24051 18.0366C8.29615 17.7122 8.1886 17.3812 7.95291 17.1514L2.56471 11.8992C1.97119 11.3207 2.2987 10.3127 3.11892 10.1935L10.5652 9.11154C10.8909 9.06421 11.1725 8.85964 11.3182 8.56449L14.6483 1.81699Z"
                );
                starPath.setAttribute(
                    "fill",
                    i < rating ? "#F8A002" : "#E0E0E0"
                );
                starSVG.appendChild(starPath);

                starContainer.appendChild(starSVG);
            }
        });
    }

    setStars();

    // Add tags/badges for the itinerary boxes
    const infoContainers = document.querySelectorAll('.itinerary-include-list-item .info');

    infoContainers.forEach(parentDiv => {
        const divElement = parentDiv.querySelector('div');

        if (divElement) {
            const items = divElement.textContent.trim().split(',');
            divElement.innerHTML = '';

            const fragment = document.createDocumentFragment();

            items.forEach(item => {
                const newSpan = document.createElement('span');
                newSpan.textContent = item.trim();
                fragment.appendChild(newSpan);
            });

            divElement.appendChild(fragment);
        }
    });
});

document.addEventListener("DOMContentLoaded", () => {
    const tab1Button = document.getElementById("tabs-nav-1");
    const tab2Button = document.getElementById("tabs-nav-2");
    const tab1Content = document.querySelector(".home-destinations-tabs-1");
    const tab2Content = document.querySelector(".home-destinations-tabs-2");

    const masonryContainers = document.querySelectorAll(
        ".home-destinations-tabs-wrapper"
    );
    const masonryContainerDestination = document.querySelectorAll(
        ".destinations-wrapper"
    );

    function initializeMasonry(container, itemSelector) {
        if (container && typeof jQuery !== 'undefined' && $(container).length) {
            $(container).imagesLoaded(function() {
                $(container).masonry({
                    itemSelector: itemSelector,
                    gutter: 32,
                });
            });
        }
    }

    masonryContainers.forEach((container) => {
        initializeMasonry(container, ".home-destinations-tabs-item");
    });

    masonryContainerDestination.forEach((container) => {
        initializeMasonry(container, ".destination-card");
    });

    // --- Tab Functionality ---
    if (tab1Button && tab2Button && tab1Content && tab2Content) {
        tab1Button.classList.add("active");
        tab2Content.style.display = "none";

        function activateTab(tabNumber) {
            tab1Button.classList.remove("active");
            tab2Button.classList.remove("active");
            tab1Content.style.display = "none";
            tab2Content.style.display = "none";

            let activeMasonryContainer;
            if (tabNumber === 1) {
                tab1Button.classList.add("active");
                tab1Content.style.display = "block";
                activeMasonryContainer = tab1Content.querySelector(
                    ".home-destinations-tabs-wrapper"
                );
            } else if (tabNumber === 2) {
                tab2Button.classList.add("active");
                tab2Content.style.display = "block";
                activeMasonryContainer = tab2Content.querySelector(
                    ".home-destinations-tabs-wrapper"
                );
            }

            if (activeMasonryContainer && typeof jQuery !== 'undefined' && $(activeMasonryContainer).data('masonry')) {
                $(activeMasonryContainer).masonry("layout");
            } else if (activeMasonryContainer && typeof jQuery !== 'undefined') {
                initializeMasonry(activeMasonryContainer, ".home-destinations-tabs-item");
            }
        }

        tab1Button.addEventListener("click", function (event) {
            event.preventDefault();
            activateTab(1);
        });

        tab2Button.addEventListener("click", function (event) {
            event.preventDefault();
            activateTab(2);
        });
    }
});